import React from "react";
import TgridFlexPostItems from "./TgridFlexPostItems";

const TgridFlexPostsFun = (props) => {
  return (
    <div className="posts-grid">
      {props.postFunction.map((post, index) => (
        <TgridFlexPostItems
          key={post.uid || post._id || index} // Added a key here to prevent React console warnings
          onEditPost={props.onEditPost}
          postFunction={post}
        />
      ))}
    </div>
  );
};

export default TgridFlexPostsFun;
